<script lang="ts" setup>
import type { Props } from './UiPreview4Floating.vue'

const props = defineProps<Props>()
const open = defineModel<boolean>({ required: true, default: false })
const render = ref(false)
const floating = useTemplateRef('floating')
const mobile = useMobile()

watch(
  () => open.value && !render.value,
  (on) => on && (render.value = true),
  { immediate: true },
)
defineExpose({ resizeCache: () => floating?.value?.resizeCache?.(), elemScroll: () => floating.value?.elemScroll() })

//
</script>

<template>
  <LazyUiPreviewMobile v-if="mobile && render" :elem2="() => helpers.getHTMLElement(props.elem())" :dropdown :open :exit="() => (open = false)">
    <slot name="floating" />
    <slot />
    <template v-if="$slots.bottom" #bottom><slot name="bottom" /></template>
  </LazyUiPreviewMobile>
  <LazyUiPreview4Floating v-else-if="render" v-bind="props" ref="floating" v-model="open" v-memo="[open, props]">
    <template #floating><slot name="floating" /></template>
    <slot />
    <slot name="bottom" />
  </LazyUiPreview4Floating>
</template>
